import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NgxDropzoneImagePreviewComponent, NgxDropzonePreviewComponent } from 'ngx-dropzone';

@Component({
  selector: 'rds-custom-preview-image',
  templateUrl: './custom-preview-image.component.html',
  styleUrls: ['./custom-preview-image.component.scss'],
  providers: [
    {
      provide: NgxDropzonePreviewComponent,
      useExisting: CustomPreviewImageComponent
    }
  ]
})
export class CustomPreviewImageComponent extends NgxDropzonePreviewComponent implements OnInit {

  @Input() uploading:boolean = true;
  @Input() photo:any;

  deleting:boolean = false;
  constructor(sanitizer: DomSanitizer) {
    super(sanitizer);
  }

  ngOnInit() {  
    
  }

  doRemove($event){
    this.deleting = true;
    this._remove($event);
  }

}
